import React from "react";
import { Link } from "react-router-dom";
import { Alert, Card, Container, Table } from "react-bootstrap";
import { useSchedule, teamPath } from "./scheduleData";

const TeamLink = ({ team }) => (
  <Link to={teamPath(team.Name)}>
    {team.Name} <small className="text-muted">({team.Conference})</small>
  </Link>
);

const Schedule = () => {
  const { loading, error, data } = useSchedule();

  if (loading) return <Container>Loading schedule...</Container>;
  if (error) {
    return (
      <Container>
        <Alert variant="danger">{error.message}</Alert>
      </Container>
    );
  }
  if (!data.weeks) {
    return (
      <Container>
        <Alert variant="info">The NCBB schedule is currently disabled.</Alert>
      </Container>
    );
  }

  return (
    <Container>
      <h2>NCBB Out-of-Conference Schedule</h2>
      <p className="text-muted">Schedule solution {data.solution}</p>
      {data.weeks.map((matchups, i) => (
        <Card key={i} className="mb-3">
          <Card.Header>Week {i + 1}</Card.Header>
          <Card.Body>
            <Table striped size="sm" className="mb-0">
              <tbody>
                {matchups.map(([a, b]) => (
                  <tr key={`${a.Name}-${b.Name}`}>
                    <td className="text-right">
                      <TeamLink team={a} />
                    </td>
                    <td className="text-center text-muted">vs</td>
                    <td>
                      <TeamLink team={b} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      ))}
    </Container>
  );
};

export default Schedule;
